"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Device(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 12V5a2 2 0 012-2h4V2a1 1 0 00-1-1H2a1 1 0 00-1 1v9a1 1 0 001 1h6zM2 0h11a2 2 0 012 2v2h-5a1 1 0 00-1 1v8H2a2 2 0 01-2-2V2a2 2 0 012-2zM3.5 14h5a.5.5 0 010 1h-5a.5.5 0 010-1zM11.5 13h1a.5.5 0 010 1h-1a.5.5 0 010-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 00-1 1v9a1 1 0 001 1h4a1 1 0 001-1V5a1 1 0 00-1-1h-4zm0-1h4a2 2 0 012 2v9a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Device);
var _default = ForwardRef;
exports["default"] = _default;